module.exports = __webpack_public_path__ + "media/images/logo/ekuitas-sell-692b924581ef10dcc63fce302ad116fe.svg";